export const environment = {
  production: false,
  apiUrl: 'https://staging-backend.test-app.samalogistica3.com/api',
  sseServerUrl: 'https://web-sse.test-app.samalogistica3.com',
  unopago: {
    apiUrl: 'https://api.unopago.com/v1',
    token: 'sk_test_staging_XXXXXXXXXXXXXXXXXXXXXX'
  }
};